import { create } from 'zustand'

export interface ThumbnailTrackingEntry {
  lineId: string
  planId: string
  versionId: string
  eventsUrl: string
}

interface ThumbnailTrackingState {
  entries: Map<string, ThumbnailTrackingEntry>
  addEntry: (entry: ThumbnailTrackingEntry) => void
  removeEntry: (lineId: string) => void
}

export const useThumbnailTrackingStore = create<ThumbnailTrackingState>(
  set => ({
    entries: new Map(),
    addEntry: entry =>
      set(state => {
        const next = new Map(state.entries)
        next.set(entry.lineId, entry)
        return { entries: next }
      }),
    removeEntry: lineId =>
      set(state => {
        const next = new Map(state.entries)
        next.delete(lineId)
        return { entries: next }
      }),
  })
)
